export const scrollToElement = (hash: string, e: { preventDefault: () => void }) => {
  e.preventDefault();

  const scrollTarget = document.querySelector(hash);

  const topOffset = () => {
    switch (hash) {
      case '#challenges':
        return 0;
      case '#overview':
        return 0;
      case '#contact-form-container':
        return 0;
      default:
        return 0;
    }
  };

  if (scrollTarget) {
    const elementPosition = scrollTarget!.getBoundingClientRect().top;

    const offsetPosition = elementPosition! - topOffset();

    window.scrollBy({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
};
